import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { Helmet } from "react-helmet-async";
import Swal from "sweetalert2";

const JenisPembayaran = () => {
    const [kelas, setKelas] = useState([]); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // State untuk loading
    const [nominal, setNominal] = useState(''); 
    const [jenistagihan, setjenistgaihan] = useState('Bulanan'); 

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
 const formatRupiah = (angka) => {
    let number_string = angka.replace(/[^,\d]/g, '').toString();
    let split = number_string.split(',');
    let sisa = split[0].length % 3;
    let rupiah = split[0].substr(0, sisa);
    let ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }

    rupiah = split[1] !== undefined ? rupiah + ',' + split[1] : rupiah;
    return rupiah ? 'Rp ' + rupiah : '';
  };

  const handleChangematauang = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setNominal(formatRupiah(e.target.value))

  };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Aktifkan loading
        console.log(formData)

        Swal.fire({
            title: "Menyimpan...",
            text: "Mohon tunggu sebentar.",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/bendahara/inputjenispembayaran`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data");
            }

            const result = await response.json();

            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });

            setError('');
            setFormData({
                rombel_id: "",
                initial: "",
                nama_rombel: "",
                tingkat: "10",
                jenis_rombel: "Umum"
            });

        } catch (error) {
            Swal.fire("Error!", error.message || 'Terjadi kesalahan', "error");
            setError(error.message || 'Terjadi kesalahan');
        } finally {
            setIsLoading(false); // Matikan loading setelah proses selesai
        }
    };

    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
    };

    const handleNew = () => {
        setIsEditing(false);
        setFormData({
           
        });
    };

    useEffect(() => {


        $('.table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/bendahara/getjenispembayaran`,
                type: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
                dataSrc: "data",
            },
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.nama_pembayaran}</b>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>Rp. ${data.nominal}</b>`;
                    }
                },
               {
    data: null,
    render: function (data, type, row, meta) {
        function formatTanggal(iso) {
            const date = new Date(iso);
            return date.toLocaleDateString('id-ID', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        }

        let jth = "";
        if (data.jenis_tagihan === "Sekali") {
            const mulai = formatTanggal(data.jatuh_tempo);
            const akhir = formatTanggal(data.max_jatuh_tempo);
            jth = `${mulai} - ${akhir}`;
        } else {
            const mulai = data.tgl_jatuh_tempo; // diasumsikan bukan ISO string
            const akhir = data.max_tgl_jatuh_tempo;
            jth = `Setiap Tanggal (${mulai}) - Hingga (${akhir})`;
        }

        return `<b>${jth}</b>`;
    }
},

                 {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<small>${data.jenis_tagihan}</small>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<small>${data.cicilan===1?"Bisa Dicicil":"Tidak"}</small>`;
                    }
                },
               
                {
                    data: null,
                    render: function (data, type, row) {
                        setKelas(row)
                        return `
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${JSON.stringify(row)}'>
                                <i class="ti ti-edit f-20"></i>
                            </a>
                            <!--<a href="#" class="delete-btn avtar avtar-xs mx-1 btn-link-danger" data-id="${row.kode_jenis_pembayaran }">
                                <i class="ti ti-trash f-20"></i>
                            </a>-->
                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });

        return () => {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }
        };
    }, []);


    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");

        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                console.log({ rombel_id: id })
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapuskelas`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem('authToken')}`
                    },
                    body: JSON.stringify({ rombel_id: id })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                            $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                        } else {
                            Swal.fire("Gagal!", data.message, "error");
                        }
                    })
                    .catch(error => {
                        Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                    });
            }
        });
    });

    const getotomatiskode =async ()  =>{
  try {
                 const response = await fetch(`${process.env.REACT_APP_BASE_URL}/bendahara/getautokode`, {
                     method: 'GET',
                     headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                     },
                 });
 
                 if (!response.ok) {
                     throw new Error("Failed to fetch kelas");
                 }
 
                 const data = await response.json();
 
                 console.log(data)
               
 
             } catch (error) {
                 Swal.fire("Error!", error.message || 'Something went wrong', "error");
             }
    }


    return (
        <>
            <Helmet>
                <title>Kelas Griya Vidya</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className='row mb-3 align-items-center'>
                                            <div className="col"><small className="text-muted">Refrensi</small><h3>Jenis Pembayaran</h3></div>

                                            <div className='col-auto'>
                                                <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button></div>
                                        </div>
                                        <hr />
                                        {/* Tabel kelas */}
                                        <table className="table table-hover datatable-table" >
                                            <thead>
                                                <tr>
                                                    <th width="50">#</th>
                                                    <th scope="col">Nama</th>
                                                    <th scope="col">Nominal</th>
                                                      <th scope="col">Jatuh Tempo</th>
                                                    <th width="50"><center>Jenis</center></th>
                                                    <th width="50"><center>Cicilan</center></th>
                                                    <th width="50"><center>Action</center></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                        {/* Tampilkan error jika ada */}
                                        {error && <div className="alert alert-danger">{error}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal Input/Edit */}
                <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog">
                        <form onSubmit={handleSubmit} className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{isEditing ? "Edit Jenis Pembayaran" : "Tambah Jenis Pembayaran"}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                {/* <div className="mb-3">
                                    <label className="form-label">Kode Pembayaran</label>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" />
                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" onClick={
                                            ()=>{
                                                getotomatiskode()
                                            }
                                        }>Otomatis</button>
                                    </div>
                                </div> */}

                                <div className="mb-3">
                                    <label className="form-label">Nama</label>
                                    <input type="text" className="form-control" name="nama_pembayaran" value={formData.nama_pembayaran}  onChange={handleChange} required />
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">Jenis Tagihan</label>
                                    <select name='jenis_tagihan' className="form-select" value={formData.jenis_tagihan} 
                                    
                                     onChange={(e) =>{
                                        setFormData({
                                            ...formData,
                                            jenis_tagihan: e.target.value
                                            })
                                            setjenistgaihan(e.target.value)
                                     }
                                            
                                        }
                                        required>
                                        <option value={"Bulanan"}>Bulanan</option>
                                        <option value={"Sekali"}>Sekali</option>
                                    </select>
                                </div>
                                {jenistagihan=="Sekali" ? (
                                    <>
                                     <div className="mb-3">
                                    <label className="form-label">Jatuh Tempo</label>
                                    <input type="date" className="form-control" name="jatuh_tempo" value={formData.jatuh_tempo} onChange={handleChange} required />
                                </div>
                                  <div className="mb-3">
                                    <label className="form-label">Max Jatuh Tempo</label>
                                    <input type="date" className="form-control" name="max_jatuh_tempo" value={formData.max_jatuh_tempo} onChange={handleChange} required />
                                </div>
                                    </>
                                ):(
 <>
                                     <div className="mb-3">
                                    <label className="form-label">Jatuh Tempo Setiap Tanggal</label>
                                    <input type="number" className="form-control" name="tgl_jatuh_tempo" value={formData.tgl_jatuh_tempo} onChange={handleChange} required />
                                </div>
                                   <div className="mb-3">
                                    <label className="form-label">Max Hari Jatuh Tempo Setiap Tanggal</label>
                                    <input type="number" className="form-control" name="max_tgl_jatuh_tempo" value={formData.max_tgl_jatuh_tempo} onChange={handleChange} required />
                                </div>
                                    </>
                                )}
                                

                                <div className="mb-3">
                                    <label className="form-label">Nominal pembayaran</label>
                                    <input type="text" className="form-control" name="nominal" value={nominal} onChange={handleChangematauang} required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Cicilan</label>
                                    <select name='cicilan' className="form-select" value={formData.cicilan}    onChange={(e) =>
                                            setFormData({
                                            ...formData,
                                            cicilan: e.target.value
                                            })
                                        } required>
                                        <option value={0}>Tidak</option>
                                        <option value={1}>Bisa Dicicil</option>
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Batal
                                </button>
                                <button type="onSubmit" className="btn btn-primary" data-bs-dismiss="modal" disabled={isLoading}>

                                    {isLoading ? "Menyimpan..." : isEditing ? "Update" : "Simpan"}

                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </>
    );
};

export default JenisPembayaran;
